import React from 'react';
import { render } from 'react-dom';
import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var emptyCatalogData = {
    catalog: [],
    minLevel: 7
};
var MessageService = /*#__PURE__*/ function() {
    function MessageService(val) {
        var _this = this;
        _classCallCheck(this, MessageService);
        this.val = val;
        this.fs = [];
        this.on = function(fn) {
            _this.fs.push(fn);
        };
        this.emit = function(newVal) {
            _this.val = newVal;
            _this.fs.forEach(function(f) {
                return f(newVal);
            });
        };
        this.remove = function(fn) {
            var index = _this.fs.findIndex(function(f) {
                return f === fn;
            });
            if (index > -1) {
                _this.fs.splice(index, 1);
            }
        };
        this.val = val;
    }
    _createClass(MessageService, [
        {
            key: "value",
            get: function get() {
                return this.val;
            }
        }
    ]);
    return MessageService;
}();
var catalogService = new MessageService(emptyCatalogData);

var HEAD_LEVEL = 7;
var numberHeadingFactory = function(minLevel) {
    var numbers = [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    return function(index) {
        for(var i = 1; i < index; i++){
            if (numbers[i] === 0) {
                numbers[i] = 1;
            }
        }
        numbers[index] += 1;
        for(var i1 = index + 1; i1 < HEAD_LEVEL; i1++){
            numbers[i1] = 0;
        }
        return "".concat(numbers.slice(minLevel, index + 1).join("."));
    };
};
var prefixFactory = function(style, minLevel) {
    var numberHeading = style === "number" ? numberHeadingFactory(minLevel) : function() {
        return "";
    };
    var prefix;
    switch(style){
        case "point":
            prefix = /*#__PURE__*/ React.createElement("div", {
                className: classNamePrefix("icon-round-preview")
            });
            break;
        case "circle":
            prefix = /*#__PURE__*/ React.createElement("div", {
                className: classNamePrefix("icon-ring-preview")
            });
            break;
        case "rect":
            prefix = /*#__PURE__*/ React.createElement("div", {
                className: classNamePrefix("icon-rect-preview")
            });
            break;
        default:
            prefix = null;
            break;
    }
    return function(level) {
        if (style !== "number") {
            return prefix;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "number"
        }, numberHeading(level), "\xa0");
    };
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".pk-view-container .ct-catalog-view{border:1px solid transparent;display:flex;flex-direction:column;padding:8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-width:400px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pk-view-container .ct-catalog-view .title{color:#3d91f2;cursor:pointer;font-size:24px;line-height:36px;margin-bottom:8px;width:auto}.pk-view-container .ct-catalog-view .number{color:#3d91f2;font-size:14px}.pk-view-container .ct-catalog-view .link-wrapper{color:#3789a9;margin:4px 0;cursor:pointer;display:flex;font-size:14px;line-height:20px;white-space:pre-wrap;word-wrap:break-word}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-round-preview{width:6px;height:6px;border-radius:50%;background-color:#333;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-ring-preview{width:6px;height:6px;border-radius:50%;border:1px solid #333;background-color:transparent;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-rect-preview{width:6px;height:6px;background-color:#333;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper svg{height:6px;margin-right:10px;margin-top:7px;min-width:6px;width:6px}.pk-view-container .ct-catalog-view .link-wrapper svg circle,.pk-view-container .ct-catalog-view .link-wrapper svg g,.pk-view-container .ct-catalog-view .link-wrapper svg path{fill:#3d91f2}.pk-view-container .ct-catalog-view .link-wrapper a{color:#3d91f2}.pk-view-container .ct-catalog-view .link-wrapper a:hover{text-decoration:underline}.pk-view-container .ct-catalog-view .indent-1{padding-left:20px}.pk-view-container .ct-catalog-view .indent-2{padding-left:40px}.pk-view-container .ct-catalog-view .indent-3{padding-left:60px}.pk-view-container .ct-catalog-view .indent-4{padding-left:80px}.pk-view-container .ct-catalog-view .indent-5{padding-left:100px}";
styleInject(css_248z);

var CatalogView = function(param) {
    var style = param.style, catalog = param.catalog, minLevel = param.minLevel;
    var factory = prefixFactory(style, minLevel);
    var links = catalog.map(function(param) {
        var key = param.key, level = param.level, text = param.text, scrollIntoView = param.scrollIntoView;
        var indent = level - minLevel;
        var prefix = factory(level);
        return /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: "indent-".concat(indent, " link-wrapper")
        }, prefix, /*#__PURE__*/ React.createElement("a", {
            className: "link",
            onClick: scrollIntoView
        }, text));
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "ct-catalog-view"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "title"
    }, "目录"), links);
};

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var HEAD_LEVEL$1 = 7;
var getCatalog = function($conatiner) {
    var $headingNodes = $conatiner.querySelectorAll("h1, h2, h3, h4, h5, h6");
    var catalog = [];
    var minLevel = HEAD_LEVEL$1;
    $headingNodes.forEach(function($node) {
        if ($node.textContent === null) {
            return;
        }
        var text = $node.textContent.replace(/\s/g, "").replace(/#/g, "");
        if (!text) {
            return;
        }
        var level = parseInt($node.nodeName.slice(1), 10);
        if (level < minLevel) {
            minLevel = level;
        }
        catalog.push({
            key: $node.id,
            text: $node.textContent,
            level: level,
            scrollIntoView: function() {
                return $node.scrollIntoView();
            }
        });
    });
    return {
        catalog: catalog,
        minLevel: minLevel
    };
};
var catalogRender = function catalogRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    _classCallCheck$1(this, catalogRender);
    this.containerRender = function($conatiner) {
        var _getCatalog = getCatalog($conatiner), catalog = _getCatalog.catalog, minLevel = _getCatalog.minLevel;
        var catalogNodes = $conatiner.querySelectorAll(_this.fragmentCls);
        catalogNodes.forEach(function(node) {
            var style = node.getAttribute("data-style") || "none";
            var newNode = document.createElement("div");
            node.parentNode.insertBefore(newNode, node.nextSibling);
            render(/*#__PURE__*/ React.createElement(CatalogView, {
                style: style,
                catalog: catalog,
                minLevel: minLevel
            }), newNode);
            node.parentNode.removeChild(node);
        });
    };
    this.fragmentCls = ".".concat(classNamePrefix("edit-catalog"));
    this.config = config;
};

export default catalogRender;
//# sourceMappingURL=render.js.map
